export default __webpack_public_path__ + "static/img4-89de09716e5adc1b95b85b7b24bda7e4.png";